// extracted by mini-css-extract-plugin
export var actionText = "_qd-4";
export var container = "_qd-0";
export var leftSection = "_qd-1";
export var rightSection = "_qd-2";
export var settingsButton = "_qd-6";
export var settingsIcon = "_qd-7";
export var shortcut = "_qd-5";
export var shortcutGroup = "_qd-3";